export enum ProductRangeEnum {
  Iman = 'IMAN',
  IncomeMax = 'INCOME_MAX',
  BrokerExclusive = 'BROKER_EXCLUSIVE',
}
